require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-team-directora-ejecutiva.json") })
        }
      }, "path---es-mx-team-directora-ejecutiva");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-team-directora-ejecutiva!./.cache/json/es-mx-team-directora-ejecutiva.json
// module id = 913
// module chunks = 231608221292675